import { render, staticRenderFns } from "./EditOutboundRuleset.vue?vue&type=template&id=21153e6e&scoped=true&"
import script from "./EditOutboundRuleset.vue?vue&type=script&lang=js&"
export * from "./EditOutboundRuleset.vue?vue&type=script&lang=js&"
import style0 from "./EditOutboundRuleset.vue?vue&type=style&index=0&id=21153e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21153e6e",
  null
  
)

export default component.exports